export interface ReportRiskProfileDataModel {
  ulid: string;
  unit: string;
  risk_category_level_1: string;
  risk_category_level_2: string;
  risk_description: string;
  risk_description_text: string;
}

export interface ReportRiskProfileFilterDataModel {
  groups: ReportRiskProfileFilterModel[];
  projects: ReportRiskProfileFilterModel[];
  entities: ReportRiskProfileFilterModel[];
  risk_categories: ReportRiskProfileFilterModel[];
  risk_implementation_status: ReportRiskProfileFilterModel[];
  risk_levels: ReportRiskProfileFilterModel[];
  risk_officers: ReportRiskProfileFilterModel[];
  risk_status: ReportRiskProfileFilterModel[];
  risk_submission_status: ReportRiskProfileFilterModel[];
  positions: ReportRiskProfileFilterModel[];
}

export interface ReportRiskProfileFilterModel {
  key: string;
  value: string;
}

export interface ReportRiskProfileModel {
  main: {
    data: ReportRiskProfileDataModel[];
    total: number;
  };
  riskProfileFilter: {
    data: ReportRiskProfileFilterDataModel;
  };
}

export enum ReportRiskProfileActionType {
  GetRiskProfileFilter = "⌘➝Report➝RiskProfile➝GetRiskProfileFilter",
  GetRiskProfile = "⌘➝Report➝RiskProfile➝GetRiskProfile",
}

export type ReportRiskProfileAction =
  | {
      data: {
        data: ReportRiskProfileFilterDataModel;
      };
      type: ReportRiskProfileActionType.GetRiskProfileFilter;
    }
  | {
      data: {
        data: ReportRiskProfileDataModel[];
        total: number;
      };
      type: ReportRiskProfileActionType.GetRiskProfile;
    };
